import React, { useState } from 'react';

import { useAuthModal } from '../hooks/useAuthModal';
import { useEscapeKey } from '../hooks/useEscapeKey';

import { AuthModalContent } from './AuthModalContent';
import { createEmailAuthHandler } from './AuthModalHelpers';
import { DisposableEmailNoticeModal } from './DisposableEmailNoticeModal';
import { ModalBackdrop } from './ModalBackdrop';

interface AuthModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AuthModalWrapper: React.FC<AuthModalWrapperProps> = ({ isOpen, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState<string | undefined>(undefined);

  const [showDisposableNotice, setShowDisposableNotice] = useState(false);

  const { handleGoogleLogin, handleAppleLogin, handleMicrosoftLogin, handleGitHubLogin } = useAuthModal();

  const handleEmailLogin = createEmailAuthHandler(setIsLoading, setError, onClose, () => setShowDisposableNotice(true));

  useEscapeKey(isOpen, onClose);

  return (
    <>
      <ModalBackdrop onClick={onClose} isVisible={isOpen}>
        <AuthModalContent
          onClose={onClose}
          handleGoogleLogin={handleGoogleLogin}
          handleAppleLogin={handleAppleLogin}
          handleMicrosoftLogin={handleMicrosoftLogin}
          handleGitHubLogin={handleGitHubLogin}
          handleEmailLogin={handleEmailLogin}
          isLoading={isLoading}
          error={error}
          setError={setError}
        />
      </ModalBackdrop>
      <DisposableEmailNoticeModal
        isOpen={showDisposableNotice}
        onClose={() => setShowDisposableNotice(false)}
      />
    </>
  );
};
